// src/newComponents/event/Events.jsx
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import EventTable from "./EventTable";
import { DataContext } from "../context/DataContext";
import LoadingScreen from "../utilities/LoadingScreen";

const Events = () => {
  // use upsertEvent so it works for both create (insert) and update (replace)
  const { loading, upsertEvent } = useContext(DataContext);
  const location = useLocation();

useEffect(() => {
  const newEvt = location.state?.newEvent;
  if (newEvt) {
    const normalized = { ...newEvt, eventID: newEvt.eventID || newEvt.eventId || newEvt.id };
    upsertEvent(normalized);
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}, [location.state, upsertEvent]);

  // If your global `loading` sometimes reflects unrelated fetches and hides the list,
  // you can choose to render the table even while loading:
  // return (
  //   <div className="lg:mr-[2vw] mt-0">
  //     {loading && <LoadingScreen />}
  //     <EventTable Dashboard={false} />
  //   </div>
  // );

  if (loading) return <LoadingScreen />;

  return (
    <div className="lg:mr-[2vw] mt-0">
      <EventTable Dashboard={false} />
    </div>
  );
};

export default Events;



// import React, { useContext } from "react";
// import EventTable from "./EventTable";
// import { DataContext } from "../context/DataContext";
// import LoadingScreen from "../utilities/LoadingScreen";

// const Events = () => {
//   const { eventData, loading } = useContext(DataContext);
//   if (loading) <LoadingScreen />;

//   return (
//     <div className="lg:mr-[2vw] mt-0">
//       <EventTable eventData={eventData} Dashboard={false} />
//     </div>
//   );
// };

// export default Events;
